//function imports
import { get_cookie } from './function/common.js';

//class imports
import { cCart } from './class/cart.js';
import { cUser } from './class/user.js';
import { cEditor } from './class/editor.js';
import { cTrip } from './class/trip.js';
import { cMedia } from './class/media_gallery.js';
import { cExpenseManager } from './class/expense_manager.js';
import { cEventManager } from './class/event_manager.js';
import { cTripManager } from './class/trip_manager.js';
import { cTripAttributes } from './class/trip_attributes.js';
import { cTripOrganize } from './class/trip_organize.js';
import { cSearch } from './class/search.js';
import { cContent } from './class/content.js';
import { cPublish } from './class/publish.js';

var Cart = new cCart();
var User = new cUser();
var Editor = new cEditor();
var Trip = new cTrip();
var Media = new cMedia();
var ExpenseManager = new cExpenseManager();
var EventManager = new cEventManager();
var TripManager = new cTripManager();
var TripAttributes = new cTripAttributes();
var TripOrganize = new cTripOrganize();
var Map = document.getElementById("map") ? L.map('map').setView([39.8282, -98.5796], 4) : false;
var Search = new cSearch();
var Content = new cContent();
var Publish = new cPublish();


export {Cart, User, Editor, Trip, Media, ExpenseManager, EventManager, TripManager, TripAttributes, TripOrganize, Map, Search, Content, Publish};


let user_cookie = get_cookie('jb_user');
if(user_cookie && user_cookie.id > 0){
	User.set_user(user_cookie);
}

import { map_state, map_error, on_map_click } from './runtime/registerMap.js';

//Map Class is only created if #map exists.
//Build supporting systems for it if it has been registered
if(Map){

	console.log("(runtime) Jaxbend - MAP found, loading MAP system");

	L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
		maxZoom: 18,
		attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
	}).addTo(Map) 

	/******
	***
		START OF VARS
	***
	******/

	// Create a custom control class
	var MapState = L.Control.extend({
		onAdd: function(map) {
			var container = L.DomUtil.create('div', 'map__state');
			container.innerHTML = `
				<div class="map__focus">
					<span class="material-symbols-outlined">
						center_focus_weak
					</span>
					Focus Trip Origin
				</div>
				<div class="map__mode">Read Only Mode</div>
				<div class="map__response"></div>
				<form class="map__search">
					<input type="text" name="q" value="" />
					<button class="material-symbols-outlined">
						search
					</button>
				</form>`;
				
			// Prevent click events from propagating to the map
			L.DomEvent.disableClickPropagation(container);
			
			return container;
		},

		onRemove: function(map) {
			// Nothing to do here
		}
	});
	let options = {
		position: 'topright' // Choose a position (topleft, topright, bottomleft, bottomright)
	};
	
	// Add the control to the map
	new MapState(options).addTo(Map);


	/******
	***
		END OF VARS
	***
	******/



	/******
	***
		LISTENER SYSTEMS
	***
	******/
			
	//GENERAL MAP CLICK EVENT
	Map.on('click', function(e){
		
		if(map_state() == 'active' || map_state() == 'update'){
		
			//get the data from the click event
			let latlng = on_map_click(e);
			
			//do a quick update, this is primarily here to handle the TRIP and USER centering systems
			if($('.lat_focus').length > 0){
				$('.lat_focus').val(`${latlng.origin.lat}`);
			}
			if($('.lng_focus').length > 0){
				$('.lng_focus').val(`${latlng.origin.lng}`);
			}
			if($('.zoom_focus').length > 0){
				$('.zoom_focus').val(`${latlng.zoom}`)
			}
			

			if($('.latlng_text')){
				$('.latlng_text').html(`[${latlng.origin.lat}, ${latlng.origin.lng}]`)
			}
			if($('.zoom_text')){
				$('.zoom_text').html(`${latlng.zoom}`)
			}
		}else{
			//this action is available in active/update modes, throw the error that matches this
			map_error(['active', 'update']);
		}
	});
		
	Map.on('moveend', function() {
		if(Search.active){
			
			//get new map center
			let center = Map.getCenter();
			
			//update the search class
			Search.bounds = Map.getBounds();
			Search.s = null;
			Search.lat = center.lat;
			Search.lng = center.lng;
			
			if(Search.triggered_move){
				Search.triggered_move = false;
			}else{
				
				//update the url if someone links the page
				const url = new URL(window.location.href);
				url.searchParams.delete('s');
				url.searchParams.set('lat', Search.lat);
				url.searchParams.set('lng', Search.lng);
				url.searchParams.set('zoom', Map.getZoom());
				window.history.replaceState(null, '', url.toString());
				
			}
			
			//search the database
			Search.search(Search.bounds);
			
		}
	})
}